/**
 * お気に入り登録のログイン誘導モーダル。
 *
 * 未ログインでお気に入りボタンを押したときに、理由を示してからログインへ誘導する。
 * 従来は各所で直接 /account/login へリダイレクトしていた。
 *
 * 開閉はテーマ既存の Modal(assets/theme.js)に任せる。
 * Modal は document.body に対して '[data-action="open-modal"]' のクリックを
 * 委譲で拾っているため、非表示のトリガーを合成してクリックすれば開く。
 */
(function () {
  var MODAL_ID = 'modal-wishlist-login';

  /** 開けなかったときのフォールバック。 */
  function redirectToLogin() {
    window.location.href =
      '/account/login?return_url=' + encodeURIComponent(window.location.href);
  }

  /**
   * モーダルを開く。
   * モーダルが無い(= ログイン済み、またはスニペット未設置)場合は false を返す。
   *
   * 注意: 戻り値の true は「開く操作を実行した」という意味で、
   * 「開いた」ことの保証ではない。theme.js の Modal は fastdom.mutate() 経由で
   * 次フレームに aria-hidden を書き換えるため、この関数の中では結果を判定できない。
   * 実際に開いたかを見たい場合は requireLoginForWishlist() を使うこと。
   */
  window.openWishlistLoginModal = function () {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return false;

    // ログイン後に元のページへ戻す。
    // Liquid の canonical_url ではバリエーション選択(?variant=)が落ちるため、
    // 開く直前に実際のURLで組み立てる。
    var links = modal.querySelectorAll('[data-wishlist-login-link], [data-wishlist-register-link]');
    var returnUrl = encodeURIComponent(window.location.href);

    for (var i = 0; i < links.length; i++) {
      var base = links[i].getAttribute('href').split('?')[0];
      links[i].setAttribute('href', base + '?return_url=' + returnUrl);
    }

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.setAttribute('data-action', 'open-modal');
    trigger.setAttribute('aria-controls', MODAL_ID);
    trigger.style.display = 'none';
    document.body.appendChild(trigger);
    trigger.click();
    document.body.removeChild(trigger);

    return true;
  };

  /**
   * 未ログイン時の共通処理。
   * モーダルが出せればモーダルを開くだけで、ページ遷移はしない。
   *
   * theme.js が未初期化などで本当に開けなかったときだけ、
   * 無反応にならないようリダイレクトへフォールバックする。
   * aria-hidden の書き換えは次フレーム以降なので、
   * クリック直後ではなく数フレーム様子を見てから判定する。
   * 開いたのを確認した時点でポーリングを止めるため、
   * すぐ閉じられてもリダイレクトは発生しない。
   */
  window.requireLoginForWishlist = function () {
    var modal = document.getElementById(MODAL_ID);

    if (!modal || !window.openWishlistLoginModal()) {
      redirectToLogin();
      return;
    }

    var framesLeft = 20; // 約0.3秒。defer読み込みの theme.js は通常これより早く動く。

    (function waitForOpen() {
      if (modal.getAttribute('aria-hidden') === 'false') return;

      if (--framesLeft <= 0) {
        redirectToLogin();
        return;
      }

      window.requestAnimationFrame(waitForOpen);
    })();
  };
})();
